import { CurrencyAmount } from '~/components/component-library'
import { SponsoredBadge } from '~/components/txn-display/cost-display/SponsoredBadge'
import { FeeAmount } from '~/components/txn-display/cost-display/feeAmount'
import { cn } from '~/utils/tailwind-utils'

type SponsoredFeeAmountProps = {
  fee: FeeAmount
  isSponsored: boolean
  hideBadgeText?: boolean
  // Who covered the gas, from useGasPaidByLabel. Unknown before submission.
  paidBy?: string
}

export const SponsoredFeeAmount = ({
  fee,
  isSponsored,
  hideBadgeText = false,
  paidBy,
}: SponsoredFeeAmountProps) => (
  <>
    {isSponsored ? (
      <SponsoredBadge hideText={hideBadgeText} label={paidBy ?? 'Sponsored'} />
    ) : (
      paidBy && <span className="text-secondary">{paidBy}</span>
    )}
    {fee.usd !== undefined && (
      <span
        className={cn({
          'text-secondary line-through': isSponsored,
        })}
      >
        {fee.isEstimate && '~'}
        <CurrencyAmount layout="inline" value={fee.usd} />
      </span>
    )}
  </>
)
